export default __webpack_public_path__ + "static/media/config_2.9a5f667b.png";